import Config from "./config";

/**
 * Tipi ammessi per il formato delle quote
 */
export type OddsFormat = 'decimal' | 'fractional' | 'american' | 'hongkong' | 'malay' | 'indo';

const fracMemo: Record<number, string> = {};

function eratostene(a: number, b: number): number {
	if (a === b)
		return a;
	let min = Math.min(a, b), max = Math.max(a, b);
	do {
		const tmp = min;
		min = max % min;
		max = tmp;
	} while (0 !== min);
	return max;
}

export function dec2frac(odd: number): string {
	if (fracMemo[odd])
		return fracMemo[odd];
	const intOdd = Math.round(1e5 * (odd - 1));
	const base = 1e5;
	const mcd = eratostene(intOdd, base);
	return fracMemo[odd] = [intOdd / mcd, base / mcd].join("/");
}

const decToAmerican = (odd: number): string => {
	odd -= 1;
	if (odd < 1) {
	  return "-" + (100 / odd).toFixed(0);
	} else {
	  return "+" + (odd * 100).toFixed(0);
	}
};

const dec2HK = (e: number | string): string => {
	let t: number;
    const val = typeof e === 'string' ? parseFloat(e) : e;
	return (
		(t = 1 >= val || Number.isNaN(val) ? NaN : val - 1),
		t.toFixed(2)
	);
};

const dec2Malay = (e: number | string): string => {
	let t: number;
    const val = typeof e === 'string' ? parseFloat(e) : e;
	return (
		(t = 1 >= val || Number.isNaN(val) ? NaN : 2 >= val ? val - 1 : 1 / (1 - val)),
		t.toFixed(3)
	);
};

const dec2Indo = (e: number | string): string => {
	let t: number;
    const val = typeof e === 'string' ? parseFloat(e) : e;
	return (
		(t = 1 >= val || Number.isNaN(val) ? NaN : val >= 2 ? val - 1 : 1 / (1 - val)),
		t.toFixed(3)
	);
};

const decimal = (odd: number): string => {
	if (odd < 1.01 && odd > 1) { // Questo è il sistema delle quote i BC che sotto l'1.01 mette anche 1.006, 1.005 e 1.001
		return odd.toFixed(3);
	}
	return odd.toFixed(2);
}

export function convertTo(to: OddsFormat | string, odd: number): string {
	switch (to) {
		case 'decimal':
			return decimal(odd);
		case 'fractional':
			return dec2frac(odd);
		case 'american':
			return decToAmerican(odd);
		case 'hongkong':
			return dec2HK(odd);
		case 'malay':
			return dec2Malay(odd);
		case 'indo':
			return dec2Indo(odd);
        default:
            return decimal(odd);
	}
}

// export function convert(odd) {
// 	const to = window.globalPageData.oddsDisplay || 'decimal';
// 	return convertTo(to, odd);
// }


// export default function formatOdd(odd) {
// 	// const to = window.globalPageData.oddsDisplay || 'decimal';
// 	return odd;
// }


export default function formatOdd(odd: number): string {
	const to = Config.betting['odds-format'] || 'decimal';
	return convertTo(to, odd);
}